import React, { useState, useEffect } from "react";
import Image from "react-bootstrap/Image";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { settingBusinessHandler, businessHandler } from "../../../../redux/handlers";

const formatOptionLabel = ({ label, subLabel, bankLogo, bankName }) => (
  <div className="d-flex align-items-center">
    <div className="me-2 flex-shrink-0">
      {bankLogo ? (
        <Image
          src={bankLogo}
          style={{ width: "28px", height: "28px", borderRadius: "50%", objectFit: "cover" }}
          alt={bankName}
        />
      ) : (
        <div
          style={{
            width: "28px",
            height: "28px",
            borderRadius: "50%",
            background: "#e0e0e0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "11px",
            color: "#888",
          }}
        >
          ธ
        </div>
      )}
    </div>
    <div>
      <div style={{ fontSize: "14px", color: "#2C2C2C", lineHeight: 1.3 }}>{label}</div>
      {subLabel && (
        <div style={{ fontSize: "12px", color: "#6D788D", lineHeight: 1.2 }}>{subLabel}</div>
      )}
    </div>
  </div>
);

const BusinessSettingsTabPayment = ({ formDisabled, setFormDisabled }) => {
  const dispatch = useDispatch();
  const { businessSlug } = useParams();
  const selectedBusiness = useSelector((state) => state.business.selectedBusiness);

  const [bankSettings, setBankSettings] = useState([]);
  const [selectedBankId, setSelectedBankId] = useState(null);
  const [originalBankId, setOriginalBankId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const fetchBankSettings = async () => {
    setLoading(true);
    try {
      const data = await dispatch(settingBusinessHandler.getBusinessBranchBankSettings(businessSlug));
      setBankSettings(data || []);
    } catch (err) {
      console.error("Error fetching branch bank settings:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (businessSlug) {
      fetchBankSettings();
    }
  }, [businessSlug]);

  useEffect(() => {
    if (selectedBusiness?.business?.setting_branch_bank_setting_id) {
      setSelectedBankId(selectedBusiness.business.setting_branch_bank_setting_id);
      setOriginalBankId(selectedBusiness.business.setting_branch_bank_setting_id);
    } else {
      setSelectedBankId(null);
      setOriginalBankId(null);
    }
  }, [selectedBusiness]);

  const bankOptions = bankSettings.map((account) => ({
    value: account.id,
    label: `${account.bank?.name || "-"}  •  ${account.account_name}  •  ${account.account_number}`,
    subLabel: account.branch?.branch_name ? `สาขา: ${account.branch.branch_name}` : "",
    bankLogo: account.bank?.image_path || null,
    bankName: account.bank?.name || "",
  }));

  const handleCancel = () => {
    setSelectedBankId(originalBankId);
    setFormDisabled(true);
  };

  const handleSubmit = async () => {
    setSaving(true);
    try {
      const result = await dispatch(
        settingBusinessHandler.updateBusinessSlugBankSetting(businessSlug, {
          settingBranchBankSettingId: selectedBankId,
        })
      );
      if (result === "OK") {
        setOriginalBankId(selectedBankId);
        await dispatch(businessHandler.getBusinessBySlug(businessSlug));
        setFormDisabled(true);
      }
    } catch (err) {
      console.error("Error saving bank setting:", err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <div className="card-body px-xl-4">
        <div className="py-3">
          <div className="row gx-xl-4">
            <div className="col-xl-6">
              <Form.Group className="mb-2 form-st-3 pb-1">
                <Form.Label className="mb-1">ช่องทางธนาคารหลัก</Form.Label>
                <Select
                  name="settingBranchBankSettingId"
                  className="w-100 select-st-1"
                  options={bankOptions}
                  placeholder="เลือกช่องทางธนาคาร"
                  formatOptionLabel={formatOptionLabel}
                  isLoading={loading}
                  isClearable
                  isDisabled={formDisabled}
                  value={bankOptions.find((opt) => opt.value === selectedBankId) || null}
                  onChange={(opt) => setSelectedBankId(opt ? opt.value : null)}
                  noOptionsMessage={() => "ยังไม่มีบัญชีธนาคารในระบบ"}
                />
              </Form.Group>
            </div>

            <div className="col-xl-6 text-center d-flex align-items-center justify-content-center">
              <Image src="/images/img2.png" width={143} />
            </div>
          </div>
        </div>
      </div>

      <div className="text-end pb-4 pe-3">
        {formDisabled ? (
          <Button
            type="button"
            className="btn-st-3 mx-3"
            onClick={() => setFormDisabled(false)}
          >
            แก้ไข
          </Button>
        ) : (
          <div className="text-end pt-3 btn-group-control">
            <Button
              type="button"
              className="btn-st-5 me-3"
              onClick={handleCancel}
              disabled={saving}
            >
              ยกเลิก
            </Button>
            <Button
              type="button"
              className="btn-st-3"
              onClick={handleSubmit}
              disabled={saving}
            >
              {saving ? "กำลังบันทึก..." : "บันทึก"}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default BusinessSettingsTabPayment;
